import * as user from './user'
import * as home from './home'
import * as device from './device'
import * as admin from './admin'
import * as data from './data'

const apiObj = {
    user,
    home,
    device,
    admin,
    data
}

const install = function (Vue) {
    if (install.installed) return
    install.installed = true
    Object.defineProperties(Vue.prototype, {
        $api: {
            get () {
                return apiObj
            }
        }
    })
}
export default {
    install
}



// WEBPACK FOOTER //
// ./src/api/index.js